import styled, { css } from 'styled-components';

import { breakePoints } from '~/src/features/internet/internet-represent/styled';

export const ImgContent = styled.div`
    flex: 1 1 1%;
    width: 100%;
    justify-content: center;
    align-items: center;

    @media (max-width: ${breakePoints.mobile}) {
        order: -1;
    }
`;

export const AnimationWrap = styled.div`
    position: relative;

    width: 620px;
    height: 609px;

    @media (max-width: ${breakePoints.desktop}) {
        width: 470px;
        height: 452px;
    }

    @media (max-width: ${breakePoints.laptop}) {
        width: 380px;
        height: 361px;
    }

    @media (max-width: ${breakePoints.tablet}) {
        width: 370px;
        height: 350px;
    }
`;

export const Image = styled.img`
    width: 100%;
    height: auto;
    object-fit: contain;
`;

interface IImgParams {
    top?: string,
    left?: string,
    bottom?: string,
    right?: string,
    width?: string,
    height?: string,
    rotateDegree?: string,
}

const getImgParams = (imgParams: IImgParams) => {
    let result = '';

    for (const key in imgParams) {
        result += `${key}:${imgParams[key as keyof IImgParams]};`;
    }

    return css`${result}`;
};

export const SattelitImage = styled(Image)<{imgParams?: IImgParams}>`
    position: absolute;
    transition: all 2s ease;

    width: 22%;
    height: 22%;
    ${p => p.imgParams ? getImgParams(p.imgParams) : ''}
`;

export const VideoWrap = styled.div<{imgParams?: IImgParams}>`
    position: absolute;

    width: 22%;
    height: 22%;
    ${p => p.imgParams ? getImgParams(p.imgParams) : ''}

    transition: all 2s ease;

    & > video {
        width: 100%;
        height: auto;
        object-fit: contain;
        border-radius: 16px;
        pointer-events: none;

        ${p => p.imgParams && p.imgParams.rotateDegree ? css`transform: rotate(${p.imgParams.rotateDegree});` : ''}
    }
`;
